import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { MessageorderModel } from 'projects/core/src/lib/models/messageorder.model';
import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { BaseDetail } from 'projects/admin/src/app/classes/base-detail';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { DetailModes } from 'projects/admin/src/app/shared/constants';
import { forkJoin } from 'rxjs';
import { LanguageModel } from 'projects/core/src/lib/models/language.model';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { MessageorderOptionsModel } from './models/messageorder-options.model';

@Component({
  selector: 'app-messageorder-detail',
  templateUrl: './messageorder-detail.component.html',
  styleUrls: ['./messageorder-detail.component.scss']
})
export class MessageorderDetailComponent extends BaseDetail implements OnInit {

  public messageorder: MessageorderModel = null;
  public languages: Array<LanguageModel> = [];
  public options: MessageorderOptionsModel;

  public backRoute = ['/messageorders'];
  protected identifier = 'messageorder';

  constructor(
    protected ui: UiService,
    protected router: Router,
    private api: ApiService,
    private route: ActivatedRoute,
    protected helper: HelperService,
    public transloco: TranslocoService
  ) {
    super(ui, router, helper, transloco);
  }

  ngOnInit(): void {
    let mode = null;
    const requests = [
      this.api.getModels('languages'),
      this.api.getMessageorderOptions(),
    ];
    this.route.params.subscribe(params => {
      if (params.id === 'new') {
        mode = DetailModes.new;
      } else if (params.id) {
        mode = DetailModes.edit;
        requests.push(this.api.getModel('messageorders', params.id));
      } else {
        this.onClose();
      }
      this.setLoading();
      forkJoin(requests).subscribe({
        next: (result: any) => {
          if (result[0]?.data) {
            this.languages = result[0].data.map((language: any) => {
              return new LanguageModel().deserialize(language);
            });
          }
          if (result[1]?.data) {
            this.options = new MessageorderOptionsModel().deserialize(result[1].data);
          }
          if (result[2]?.data) {
            this.messageorder = new MessageorderModel().deserialize(result[2].data);
          }
          this.tabIndex = parseInt(localStorage.getItem(this.identifier + '-tab'), 10);
          this.setInitialized(mode);
        },
        error: (error: any) => {
          this.setFailed(error);
        }
      });
    });
  }

}
